import { useTranslation } from "react-i18next";
import { cn } from "~/lib/utils";
import { type DocumentReview } from "../helpers";
import { type ChartTooltipState } from "../useChartTooltip";

interface Props {
  documentReviews: DocumentReview[];
  tooltip: ChartTooltipState<DocumentReview>;
  opacity: number;
}

export const ReviewWindowDocuments = ({
  documentReviews,
  tooltip,
  opacity,
}: Props) => {
  const { t } = useTranslation();
  const activeDocumentReview = tooltip.active?.datum;

  return (
    <ul
      className="w-full max-w-2xl gap-x-8 self-center sm:columns-2"
      style={{ opacity }}
      inert={opacity < 1}
    >
      {documentReviews.map((documentReview) => {
        const { entry, release } = documentReview;
        const isDimmed =
          activeDocumentReview !== undefined &&
          activeDocumentReview !== documentReview;

        return (
          <li
            key={entry.id}
            tabIndex={0}
            className={cn(
              "focus-visible:ring-ring flex break-inside-avoid items-center gap-2 rounded-sm py-1 text-sm transition-opacity outline-none focus-visible:ring-2",
              isDimmed && "opacity-30",
            )}
            {...tooltip.markProps(documentReview)}
          >
            <span className="min-w-0 flex-1 truncate">{entry.name}</span>
            <span className="text-muted-foreground text-xs">
              {t(($) => $.commons.workflow[release.status])}
            </span>
          </li>
        );
      })}
    </ul>
  );
};
